import Vue from 'vue'
import httpManager from '../../util/common'

let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
    }
  },
  methods: {
    clickEvent(path) {
      const {
        href
      } = this.$router.resolve({path:  path})
      window.open(href, '_blank')
    },

    getData() {
      let self = this
      self.loading = true
      let params = new Map()

      httpManager("sc_influence", params, null, null, null)
        .then(response => {
          self.data = response.data.data

        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
    getUserPrivilege(){

    }
  },
  mounted() {
    this.getUserPrivilege()
    this.getData()
  },
  watch: {
  },
  computed: {
    services() {
      return [{
        title:this.$t('topNavBar.company_esg'),
        modules:[{
          is_valid: true,
          img: '/static/images/menu/esgindustry.png',
          title: this.$t('topNavBar.esgIndustryRating'),
          path: '/esgindustry',
        },
        {
          is_valid: true,
          img: '/static/images/menu/esgcompare.png',
          title: this.$t('topNavBar.ESGCompareTool'),
          path: '/comparehome',
        },
        {
          is_valid: true,
          img: '/static/images/menu/esgfilter.png',
          title: this.$t('topNavBar.ESGFilter'),
          path: '/esgfilter',
        },
        {
          is_valid: true,
          img: '/static/images/menu/esgeventstatis.png',
          title: this.$t('topNavBar.esgHome'),
          path: '/esg',
        },
        {
          is_valid: true,
          img: '/static/images/menu/esgevent.png',
          title: this.$t('topNavBar.ESGEventFilter'),
          path: '/eventhome',
        },
        {
          is_valid: true,
          img: '/static/images/menu/esgpublicsentiment.png',
          title: this.$t('topNavBar.ESGPublicSentiment'),
          path: '/esgpublicsentiment',
        }
      ]
      },
      /*
      {
        title:"基金ESG",
        modules:[{
          is_valid: true,
          img: '/static/images/menu/supplychain.png',
          title: '基金ESG指标',
          path: '/fundesgindicators',
        },
        {
          is_valid: true,
          img: '/static/images/menu/supplyChainAnnouncement.png',
          title: '基金ESG评价',
          path: '/fundesgrating',
        },
        {
          is_valid: true,
          img: '/static/images/menu/newenergy.png',
          title: '基金比较分析',
          path: '/fundesgcompare',
        }]
      },
      {
        title:"保险ESG",
        modules:[{
          is_valid: true,
          img: '/static/images/menu/supplychain.png',
          title: '保险ESG',
          path: '/insuranceesgupload',
        },
        {
          is_valid: true,
          img: '/static/images/menu/supplyChainAnnouncement.png',
          title: '保险ESG评级',
          path: '/insuranceesgranking',
        }]
      },
      {
        title:"SFDR",
        modules:[{
          is_valid: true,
          img: '/static/images/menu/supplychain.png',
          title: 'SFDR',
          path: '/sfdrupload',
        }]
      },
      */
      {
        title: this.$t('topNavBar.industry_chain'),
        modules:[{
          is_valid: true,
          img: '/static/images/menu/supplychain.png',
          title: this.$t('topNavBar.scHome'),
          path: '/supplychain',
        },
        {
          is_valid: true,
          img: '/static/images/menu/supplyChainAnnouncement.png',
          title: this.$t('topNavBar.SupplyChainAnnouncement'),
          path: '/SupplyChainAnnouncement',
        },
        {
          is_valid: true,
          img: '/static/images/menu/newenergy.png',
          title: this.$t('topNavBar.newEnergy'),
          path: '/newenergy',
        },
        {
          is_valid: true,
          img: '/static/images/menu/driverless.png',
          title: this.$t('topNavBar.driverless'),
          path: '/driverless',
        },
        {
          is_valid: true,
          img: '/static/images/menu/5g.png',
          title: this.$t('topNavBar.fiveg'),
          path: '/fiveg',
        }]
      },
        {
        title: this.$t('topNavBar.patent'),
        modules:[{
          is_valid: true,
          img: '/static/images/menu/similaritysearch.png',
          title: this.$t('topNavBar.similarity_search'),
          path: '/similaritysearch',
        },
        {
          is_valid: true,
          img: '/static/images/menu/techniquefieldsearch.png',
          title: this.$t('topNavBar.technique_field_search'),
          path: '/techniquefieldsearch',
        }]
      },
      {
        title: this.$t('topNavBar.pollution'),
        modules:[{
          is_valid: true,
          img: '/static/images/menu/pollution.png',
          title: this.$t('topNavBar.pollutionInfo'),
          path: '/pollutionhome',
        }]
      }]
    }
  },
  created(){
  }
}
Vue.component("menu-board", vm)
export default vm



// WEBPACK FOOTER //
// ./src/home/js/menu_board.js